// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Loader_wrapper__ml2vp","loader":"Loader_loader__s6oMS"};